"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _loaderModule = _interopRequireDefault(require("./loader.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapVariantToClassName = function mapVariantToClassName(variant) {
  if (variant === "inline") {
    return "".concat(_loaderModule.default.fade, " ").concat(_loaderModule.default["loader-container"], " ").concat(_loaderModule.default["in"]);
  }

  if (variant === "list") {
    return "".concat(_loaderModule.default["loader-block"], "  ").concat(_loaderModule.default["loader-flex"]);
  }

  if (variant === "row") {
    return "".concat(_loaderModule.default["loader-block"], " ").concat(_loaderModule.default["loader-row"], " ").concat(_loaderModule.default["loader-flex"]);
  }

  if (variant === "dots") {
    return "".concat(_loaderModule.default["loader-dots"], " ");
  }

  return _loaderModule.default["text-center"];
};

var Loader = function Loader(props) {
  var id = props.id,
      variant = props.variant,
      label = props.label,
      _props$loaderTestId = props.loaderTestId,
      loaderTestId = _props$loaderTestId === void 0 ? 'loader' : _props$loaderTestId;
  var loaderClassName = mapVariantToClassName(variant);

  if (variant === "inline") {
    return _react.default.createElement("div", {
      id: id ? id : null,
      className: (0, _classnames.default)(_themeModule.default.arag, loaderClassName),
      "data-testid": loaderTestId
    }, _react.default.createElement("span", {
      id: id ? "".concat(id, "_loader") : null,
      className: _loaderModule.default["loader"]
    }), _react.default.createElement("span", {
      id: id ? "".concat(id, "_loader_label") : null,
      className: _loaderModule.default["loader-label"]
    }, label));
  }

  if (variant === "dots") {
    return _react.default.createElement("div", {
      id: id ? "".concat(id, "_loader_wrapper") : null,
      className: (0, _classnames.default)(_themeModule.default.arag, loaderClassName),
      "data-testid": loaderTestId
    }, _react.default.createElement("span", {
      id: id ? "".concat(id, "_dot_1") : null,
      className: (0, _classnames.default)(_loaderModule.default["loader-dot"], _loaderModule.default["loader-dot-1"])
    }), _react.default.createElement("span", {
      id: id ? "".concat(id, "_dot_2") : null,
      className: (0, _classnames.default)(_loaderModule.default["loader-dot"], _loaderModule.default["loader-dot-2"])
    }), _react.default.createElement("span", {
      id: id ? "".concat(id, "_dot_3") : null,
      className: (0, _classnames.default)(_loaderModule.default["loader-dot"], _loaderModule.default["loader-dot-3"])
    }));
  }

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, loaderClassName),
    "data-testid": loaderTestId
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_loader_fade_in") : null,
    className: "".concat(_loaderModule.default["fade"], " ").concat(_loaderModule.default["in"])
  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_loader") : null,
    className: _loaderModule.default["loader"]
  })));
};

Loader.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The variant of the loader */
  variant: _propTypes.default.oneOf(["inline", "list", "row", "dots"]),

  /** String text that will be displayed next to the loader when the variant prop is set to "inline" */
  label: _propTypes.default.string,

  /** Test ID for loader*/
  loaderTestId: _propTypes.default.string
};
var _default = Loader;
exports.default = _default;